export function AddIcon() {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M10 4.1665V15.8332' stroke='#F2C94C' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M4.16602 10H15.8327' stroke='#F2C94C' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}
